import { render, staticRenderFns } from "./ServerTasks.vue?vue&type=template&id=55358841&scoped=true"
import script from "./ServerTasks.vue?vue&type=script&lang=js"
export * from "./ServerTasks.vue?vue&type=script&lang=js"
import style0 from "./ServerTasks.vue?vue&type=style&index=0&id=55358841&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55358841",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55358841')) {
      api.createRecord('55358841', component.options)
    } else {
      api.reload('55358841', component.options)
    }
    module.hot.accept("./ServerTasks.vue?vue&type=template&id=55358841&scoped=true", function () {
      api.rerender('55358841', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServerTasks.vue"
export default component.exports